import { Model } from "pinia-orm";

export default class Dashboard extends Model {
  static entity = "dashboards";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      project: this.string(""),
      isGroundInvestigated: this.attr(null),
      groundInvestigationStartDate: this.string(""),
      groundInvestigationEndDate: this.string(""),
      isUndergroundWaterInvestigated: this.attr(null),
      undergroundWaterPrelevementStartDate: this.string(""),
      undergroundWaterPrelevementEndDate: this.string(""),
      undergroundWaterImplantationStartDate: this.string(""),
      undergroundWaterImplantationEndDate: this.string(""),
      isSuperficialWaterInvestigated: this.attr(null),
      superficialWaterInvestigationStartDate: this.string(""),
      superficialWaterInvestigationEndDate: this.string(""),
      isSedimentInvestigated: this.attr(null),
      sedimentInvestigationStartDate: this.string(""),
      sedimentInvestigationEndDate: this.string(""),
      isGasInvestigated: this.attr(null),
      gasImplantationStartDate: this.string(""),
      gasImplantationEndDate: this.string(""),
      gasPrelevementStartDate: this.string(""),
      gasPrelevementEndDate: this.string(""),
      isAmbientAirInvestigated: this.attr(null),
      ambientAirInvestigationStartDate: this.string(""),
      ambientAirInvestigationEndDate: this.string(""),
      isTapWaterInvestigated: this.attr(null),
      tapWaterInvestigationStartDate: this.string(""),
      tapWaterInvestigationEndDate: this.string(""),
      isVegetalInvestigated: this.attr(null),
      vegetalInvestigationStartDate: this.string(""),
      vegetalInvestigationEndDate: this.string(""),
      isLandToExcavateInvestigated: this.attr(null),
      landToExcavateInvestigationStartDate: this.string(""),
      landToExcavateInvestigationEndDate: this.string(""),
      acknowledgementOfReceiptSent: this.attr(null),
      siteVisitSent: this.attr(null),
      interventionsSent: this.attr(null),
      firstVisitSent: this.attr(null),
      secondVisitSent: this.attr(null),
      offerSent: this.attr(null),
      scheduleChangeSent: this.attr(null),
      samplingPlanSent: this.attr(null),
      analyticalProgramSent: this.attr(null),
      reportDelaySent: this.attr(null),
      cdpReviewRequestSent: this.attr(null),
      supervisionRequestSent: this.attr(null),
      reportSent: this.attr(null),
      teamChangeSent: this.attr(null),
      groundSubcontractedDrilling: this.attr(null),
      groundDrillingContractor: this.attr(null),
      undergroundWaterSubcontractedDrilling: this.attr(null),
      undergroundWaterDrillingContractor: this.attr(null),
      gasSubcontractedDrilling: this.attr(null),
      gasDrillingContractor: this.attr(null),
      landToExcavateSubcontractedDrilling: this.attr(null),
      landToExcavateDrillingContractor: this.attr(null),
    };
  }
}
